"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useForceUpdate", {
    enumerable: true,
    get: function() {
        return useForceUpdate;
    }
});
const _react = require("react");
function useForceUpdate() {
    return (0, _react.useReducer)((x)=>x + 1, 0)[1];
}
